<script>
	import { getUserActions } from "../../currentUser";
	import BarDelinquency from "./BarDelinquency.svelte";
	import BarShowEmailVerification from "./BarShowEmailVerification.svelte";
	import BarWeAreHavingIssues from "./BarWeAreHavingIssues.svelte";
	import BarExpiringOrganization from "./BarExpiringOrganization.svelte";
	import BarLoggedInAs from "./BarLoggedInAs.svelte";

	const {
		showWeAreHavingIssues,
		showDelinquencyBar,
		showEmailVerificationBar,
		expirationNotification: { showExpirationNotification },
		loggedInAs
	} = getUserActions();
</script>

{#if loggedInAs?.showLoggedInAsNotification}
	<BarLoggedInAs />
{/if}

{#if showWeAreHavingIssues}
	<BarWeAreHavingIssues />
{:else if showDelinquencyBar}
	<BarDelinquency />
{:else if showExpirationNotification}
	<BarExpiringOrganization />
{:else if showEmailVerificationBar}
	<BarShowEmailVerification />
{/if}
